








import { Component, Vue } from 'vue-property-decorator'
import Appartment from '@/views/profile/Appartment.vue'
import Progope from '@/components/ProgImmo/Progope.vue'
import Ticket from '@/components/Ticket.vue'

@Component({
    components: {
        Appartment,
        Progope,
        Ticket,
    },
})
export default class AppartmentView extends Vue {}
